import { Button, Typography } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import React from "react";
import useStyles from "./DashboardErrorState.styles";

export default function DashboardErrorState({ onRetry }) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<WarningIcon className={classes.icon} />
			<Typography
				variant="body1"
				className={classes.text}
			>
				Ocorreu um erro ao carregar as informações do dashboard.
			</Typography>
			<Button
				variant="text"
				color="primary"
				onClick={onRetry}
				className={classes.button}
			>
				Tentar novamente
			</Button>
		</div>
	);
}
